import request from '../utils/request'

export function modifyCompany(company) {
    return request({
        url: '/api/factory/modify',
        method: 'post',
        data: company
    })
}